/**
 * Regex to validate a lenient 10-digit tn format.
 *
 * @module
 *
 */
const tnRegex = /^\d{10}$/;

export { tnRegex };
